import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import noImage from '@images/icons/no-image.jpg';
import BeenhereRoundedIcon from '@mui/icons-material/BeenhereRounded';
import { TProduct } from '../../../types/Common';
import CustomButton from '../../UI/CustomButton';
import './purchases.scss';

interface ProductCardProps {
  product: TProduct;
  setOpenTransfersProduct: (open: boolean) => void;
  setOpenTestAssignmentDialog: (open: boolean) => void;
  setSelectedProduct: (product: TProduct) => void;
}

const PurchasesCard: React.FC<ProductCardProps> = (props) => {
  const { product, setOpenTransfersProduct, setSelectedProduct, setOpenTestAssignmentDialog } =
    props;
  const { productName, quantity = 0, productPic } = product;

  return (
    <Card className='cardContainer'>
      <Box className='flexCenter'>
        <img src={productPic || noImage} width={95} height={95} alt='' />

        <Box p={2}>
          <Typography color='text.main' fontWeight='bold' mb={1}>
            {productName}
          </Typography>

          <Box className='flexCenter' gap={0.5}>
            <BeenhereRoundedIcon color='success' />
            <Typography color='secondary.main'>{`تعداد موجود: ${quantity} `}</Typography>
          </Box>
        </Box>
      </Box>

      <Box className='actionFlexColumn'>
        <CustomButton
          variant='contained'
          size='small'
          onClick={() => {
            setSelectedProduct(product);
            setOpenTestAssignmentDialog(true);
          }}
        >
          انتقال به کاربر
        </CustomButton>

        <CustomButton
          variant='contained'
          size='small'
          color='secondary'
          onClick={() => setOpenTransfersProduct(true)}
        >
          جزئیات
        </CustomButton>
      </Box>
    </Card>
  );
};

export default PurchasesCard;
